/**
 * Bra size finder — required size guard for the bundle rows
 * ---------------------------------------------------------------------------
 * When a "Bra size finder" block is present, the Size dropdown of every
 * .variant-row in the Buy buttons block renders empty. This script:
 *   - keeps the add to cart button clickable while that size is missing,
 *     so the shopper gets an explanation instead of a dead button,
 *   - blocks the add to cart and shows the message,
 *   - clears everything as soon as a size is chosen (in the finder, in the
 *     bundle dropdown, or through the theme's own variant picker).
 */
(function () {
  if (window.__bsfRequiredInit) return;
  window.__bsfRequiredInit = true;

  var REQUIRED = '.custom-dropdown--required';
  var ATC = '[data-add-to-cart]';
  var FALLBACK_MESSAGE = 'Please choose your size before adding to cart.';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function config() {
    var el = document.querySelector('[data-bsf-required-config]');
    return {
      message: (el && el.dataset.message) || FALLBACK_MESSAGE,
      label: (el && el.dataset.label) || 'Size',
      color: (el && el.dataset.color) || '#B3261E',
    };
  }

  /* ------------------------------------------------------------- state --- */

  /** The bundle the shopper is actually buying (BUY 1 / BUY 2 / BUY 3). */
  function activeContainer() {
    var checked = document.querySelector('input[name="bundle_choice"]:checked');
    if (!checked) return null;
    return document.getElementById('bundle-' + checked.value + '-variants');
  }

  function selectOf(dropdown) {
    return dropdown.querySelector('.variant-select');
  }

  function isEmpty(dropdown) {
    var select = selectOf(dropdown);
    return !select || !select.value || !select.value.trim();
  }

  /** Required dropdowns of the bundle being bought. */
  function scopedRequired() {
    var scope = activeContainer();
    if (scope) return toArray(scope.querySelectorAll(REQUIRED));

    // No bundle UI: only count what the shopper can actually see.
    return toArray(document.querySelectorAll(REQUIRED)).filter(function (dropdown) {
      return dropdown.offsetParent !== null;
    });
  }

  function missing() {
    return scopedRequired().filter(isEmpty);
  }

  function syncEmptyState() {
    toArray(document.querySelectorAll(REQUIRED)).forEach(function (dropdown) {
      var empty = isEmpty(dropdown);
      dropdown.classList.toggle('is-empty', empty);
      if (!empty) dropdown.classList.remove('is-invalid');
    });
  }

  /* ----------------------------------------------------------- message --- */

  function messageHost() {
    return (
      activeContainer() ||
      document.querySelector('.bundle-variants') ||
      document.querySelector('.product__submit')
    );
  }

  function showMessage() {
    var cfg = config();
    var host = messageHost();

    if (host) {
      var el = host.querySelector('.bundle-size-required');
      if (!el) {
        el = document.createElement('p');
        el.className = 'bundle-size-required';
        el.setAttribute('role', 'alert');
        host.appendChild(el);
      }
      el.textContent = cfg.message;
      el.hidden = false;
    }

    missing().forEach(function (dropdown) {
      dropdown.classList.add('is-invalid');
    });

    var finder = document.querySelector('bra-size-finder');
    if (!finder) return;

    var note = finder.querySelector('[data-bsf-note]');
    if (note) {
      note.textContent = cfg.message;
      note.hidden = false;
      note.dataset.bsfRequired = 'true';
    }

    try {
      if (typeof finder.scrollIntoView === 'function') {
        finder.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } catch (error) {
      // Scrolling is a nicety; never let it swallow the message.
    }
  }

  function clearMessage() {
    toArray(document.querySelectorAll('.bundle-size-required')).forEach(function (el) {
      el.hidden = true;
    });
    toArray(document.querySelectorAll(REQUIRED)).forEach(function (dropdown) {
      dropdown.classList.remove('is-invalid');
    });

    var note = document.querySelector('bra-size-finder [data-bsf-note]');
    if (note && note.dataset.bsfRequired === 'true') {
      note.hidden = true;
      note.textContent = '';
      delete note.dataset.bsfRequired;
    }
  }

  /* ------------------------------------------------------------ button --- */

  /**
   * The bundle script disables add to cart whenever a variant select is empty.
   * While the missing one is the size we drive, re-enable it so the click can
   * surface the message. A filled size hands control straight back to the theme.
   */
  function unlockButtons() {
    if (!missing().length) return;
    toArray(document.querySelectorAll(ATC)).forEach(function (button) {
      if (button.disabled) button.disabled = false;
    });
  }

  /* -------------------------------------------------------- filling in --- */

  /**
   * Copy a size resolved by the finder into every required bundle dropdown.
   * The theme's own sync only reacts to a variant picker change, so it misses
   * the case where the resolved size is the one the picker already holds.
   * Never clears: a size the shopper picked by hand stays put.
   */
  function fillRequired(size) {
    var wanted = (size || '').trim().toLowerCase();
    if (!wanted) return;

    toArray(document.querySelectorAll(REQUIRED)).forEach(function (dropdown) {
      var select = selectOf(dropdown);
      if (!select) return;

      var target = '';
      for (var i = 0; i < select.options.length; i++) {
        var value = select.options[i].value;
        if (value && value.trim().toLowerCase() === wanted) {
          target = value;
          break;
        }
      }
      if (!target || select.value === target) return;

      select.value = target;

      var text = dropdown.querySelector('.dropdown-text');
      if (text) {
        text.textContent = target;
        text.classList.remove('dropdown-text--placeholder');
      }
      toArray(dropdown.querySelectorAll('.dropdown-item')).forEach(function (item) {
        item.classList.toggle('selected', item.getAttribute('data-value') === target);
      });

      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    syncEmptyState();
    if (!missing().length) clearMessage();
    unlockButtons();
  }

  document.addEventListener('bsf:size', function (event) {
    fillRequired(event.detail && event.detail.size);
  });

  /* ------------------------------------------------------------- gates --- */

  function block(event) {
    if (!missing().length) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    showMessage();
    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest(ATC)) return;
      block(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      block(event);
    },
    true
  );

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.classList) return;
    if (!target.classList.contains('variant-select') && target.name !== 'bundle_choice') return;

    syncEmptyState();
    if (!missing().length) clearMessage();
    unlockButtons();
  });

  /* -------------------------------------------------------------- init --- */

  function refresh() {
    syncEmptyState();
    unlockButtons();
  }

  function init() {
    document.documentElement.style.setProperty('--bsf-required-color', config().color);
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', refresh);
  document.addEventListener('shopify:section:load', init);

  // The bundle script toggles [disabled] from its own timers; follow it.
  new MutationObserver(function (records) {
    var touchesButton = records.some(function (record) {
      return record.target && record.target.matches && record.target.matches(ATC);
    });
    if (touchesButton) refresh();
  }).observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['disabled'],
  });
})();
